import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from 'store'
import {
  ContentWrapper,
  H1WithBack,
  PageWrapper,
  Tabs,
  TabsContainer,
} from 'styling/GlobalStyles'
import { clearLocation, getSingleLocation, updateLocation } from 'features/locations/locationsSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { ILocationState } from 'types/locations.interface'
import { toast } from 'react-toastify'
import { getMachineryCategories } from 'features/categories/machineryCategories'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { LocationSpecificationTab } from './LocationSpecificationTab'
import { LocationMapTab } from './LocationMapTab'

export const EditLocation = () => {
  const { singleLocation } = useSelector((store: any) => store.locations)
  const [active, setActive] = useState('Specification')
  const [invalidFields, setInvalidFields] = useState([])
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { id } = useParams()
  const [state, setState] = useState<ILocationState>({
    name: '',
    type: '',
    coordinates: {
      latitude: null,
      longitude: null,
    },
    areaSize: null,
    machineryCategory: null,
    machinery: null,
    path: []
  })

  useFocusFirstInput()

  useEffect(() => {
    dispatch(getMachineryCategories(null))
    dispatch(getSingleLocation(id))

    return () => {
      dispatch(clearLocation())
    }
  }, [])

  useEffect(() => {
    if (singleLocation) {
      const obj = structuredClone(singleLocation)
      if (!(obj.type == 'static')) {
        setInvalidFields((prev: string[]) => {
          let copy = [...prev]
          copy = [...copy, 'coordinates-latitude', 'machinery']
          return copy
        })
      }
      setState(obj)
    }
    setInvalidFields([])
  }, [singleLocation])

  const handleSubmit = async () => {
    if (state?.path?.length > 0 && state?.path?.length < 3) {
      toast.warn('Location polygon must have at least 3 points.')
      return
    }
    if (invalidFields.length < 1) {
      if (state.type === 'static') {
        delete state.machinery
        delete state.machineryCategory
      }
      const resp = await dispatch(updateLocation(state))
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate('/resources/locations')
      }
    } else {
      toast.warn('All fields must be valid.')
    }
  }

  const renderTabs = () => {
    if (active === 'Specification') {
      return (
        <LocationSpecificationTab
          setState={setState}
          state={state}
          handleSubmit={handleSubmit}
          setInvalidFields={setInvalidFields}
          invalidFields={invalidFields}
        />
      )
    } else if (active === 'Map') {
      return (
        <LocationMapTab
          setState={setState}
          state={state}
          handleSubmit={handleSubmit}
        />
      )
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter >
        <H1WithBack arrow title='Edit Location' />
        <TabsContainer>
          <Tabs active={active === 'Specification'} onClick={() => setActive('Specification')}>
            Basic Info
          </Tabs>
          <Tabs active={active === 'Map'} onClick={() => setActive('Map')}>
            Map
          </Tabs>
        </TabsContainer>
        <ContentWrapper >{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </>
  )
}
